import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import { useParams } from 'react-router-dom';
import CheckedIcon from '@material-ui/icons/CheckCircle';
import NotCheckedIcon from '@material-ui/icons/HighlightOff';
import { Link } from 'react-router-dom';
import PartIcon from './PartIcon';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  done: {
    color: '#1d9021',
    marginRight: 5,
  },
  notDone: {
    color: '#ccc',
    marginRight: 5,
  },
  left: {
    color: '#666',
    paddingLeft: '2em',
    '& > span': {
      color: '#999',
    },
    '& svg': {
      verticalAlign: 'middle',
      position: 'absolute',
      left: '0.5em',
      top: '0.5em',
    },
  },
}));

function PartListItem(props) {
  const classes = useStyles();
  const { type, title, elementType, slug } = props.part;
  const params = useParams();
  const url = `/kurs/${params.course}/${params.tab}/${params.unit}/${slug}`;

  const isDone = () => {
    if (props.part.completed) {
      return <CheckedIcon className={classes.done} />
    } else {
      return <NotCheckedIcon className={classes.notDone} />
    }
  }

  const getType = () => {
    switch (elementType) {
      case 'PRESENTATION':
        return 'PREZENTACJA - ';
      case 'ACTIVATION':
        return 'AKTYWACJA - ';
      case 'EVALUATION':
        return 'EWALUACJA - ';
      case 'SUPPLEMENT':
        return 'TO SIĘ MOŻE PRZYDAĆ - ';
      default:
        return '';
    }
  }

  return (
    <>
      <Divider light />
      <ListItem button className={classes.root} component={Link} to={url}>
        <div className={classes.container}>
          <div className={classes.left}>
            <PartIcon type={type || elementType} />
            <span>{getType()}</span> {title}
          </div>
          <div className={classes.right}>
            {isDone()}
          </div>
        </div>
      </ListItem>
    </>
  );
}

export default PartListItem;